document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-filter-search]').forEach(input=>{input.addEventListener('input',()=>{let q=input.value.toLowerCase();document.querySelectorAll('[data-product-card]').forEach(card=>{card.style.display=card.textContent.toLowerCase().includes(q)?'flex':'none'})})})});
// NPC AJAX add-to-cart drawer and floating cart
(function(){
  function money(cents){
    try { return new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format((cents || 0)/100); }
    catch(e){ return '$' + ((cents || 0)/100).toFixed(2); }
  }
  function countText(count){ return count + ' item' + (count === 1 ? '' : 's'); }
  function updateCounts(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
    var floating = document.querySelector('[data-floating-cart]');
    if(floating){
      if(count > 0){
        floating.classList.remove('npc-floating-cart-hidden');
        floating.innerHTML = '🛒 <span data-cart-count>' + count + '</span> ' + countText(count) + ' · Checkout →';
      } else {
        floating.classList.add('npc-floating-cart-hidden');
      }
    }
  }
  function renderDrawer(cart){
    updateCounts(cart.item_count || 0);
    var body = document.querySelector('[data-cart-drawer-body]');
    var offer = document.querySelector('[data-cart-offer]');
    var headStrong = document.querySelector('.npc-cart-drawer-head strong');
    if(headStrong){ headStrong.innerHTML = '<span data-cart-count>' + cart.item_count + '</span> ' + (cart.item_count === 1 ? 'item' : 'items'); }
    if(body){
      if(!cart.items || cart.items.length === 0){ body.innerHTML = '<p>Your cart is empty.</p>'; }
      else {
        body.innerHTML = cart.items.map(function(item){
          return '<div class="npc-drawer-item"><strong>' + item.product_title + '</strong><small>Qty ' + item.quantity + ' · ' + money(item.final_line_price) + '</small></div>';
        }).join('');
      }
    }
  }
  function openDrawer(){
    var drawer = document.querySelector('.npc-cart-drawer');
    var backdrop = document.querySelector('.npc-cart-drawer-backdrop');
    if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); }
    if(backdrop){ backdrop.classList.add('is-open'); }
  }
  function closeDrawer(){
    var drawer = document.querySelector('.npc-cart-drawer');
    var backdrop = document.querySelector('.npc-cart-drawer-backdrop');
    if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); }
    if(backdrop){ backdrop.classList.remove('is-open'); }
  }
  document.addEventListener('click', function(e){
    if(e.target && e.target.matches('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var oldText = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{'Accept':'application/json'} })
      .then(function(r){ if(!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function(){ return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderDrawer(cart); openDrawer(); })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = oldText || 'Add To Cart'; } });
  });
})();

// Keep only the custom cart button positioned. Third-party widgets retain their native sizing and panel behavior.
(function(){
  function applyNpcCartLayout(){
    var cart = document.querySelector('[data-floating-cart], .npc-floating-cart');
    if(!cart) return;
    cart.style.setProperty('position','fixed','important');
    cart.style.setProperty('left', window.innerWidth <= 760 ? '10px' : '18px','important');
    cart.style.setProperty('right','auto','important');
    cart.style.setProperty('bottom', window.innerWidth <= 760 ? '10px' : '18px','important');
    cart.style.setProperty('z-index','60','important');
    cart.style.setProperty('max-width', window.innerWidth <= 760 ? 'calc(100vw - 168px)' : '460px','important');
  }
  document.addEventListener('DOMContentLoaded', applyNpcCartLayout);
  window.addEventListener('load', applyNpcCartLayout);
  window.addEventListener('resize', applyNpcCartLayout);
})();
